import type { UnionTypeLibelle } from "../../../techniques"

export const ModaliteFacturation = [
  'HeureStagiaire',
  'MontantGroupe',
  'MontantStagiaire',
] as const

export type ModaliteFacturation = typeof ModaliteFacturation[number]

export const ModaliteFacturationLibelle: UnionTypeLibelle<ModaliteFacturation> = {
  HeureStagiaire: 'Heures / Stagiaire',
  MontantGroupe: 'Montant / Groupe',
  MontantStagiaire: 'Montant / Stagiaire',
} as const
